import * as Yup from 'yup'

const dobValidation = Yup.object().shape({
  month: Yup.string().required('Required'),
  day: Yup.string().required('Required'),
  year: Yup.string().required('Required'),
})

export default dobValidation
